import { render, staticRenderFns } from "./RejectReportDialog.vue?vue&type=template&id=54bd1dbc&"
import script from "./RejectReportDialog.vue?vue&type=script&lang=js&"
export * from "./RejectReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports